import getConfig from 'next/config';
import { NextRouter } from 'next/router';
import { partnerFAQs } from '../../constants/partnerPageConst';
import { TFAQSection } from '../../types/partner-page-types';
import { setSessionCookie } from '../../utils/cookieUtils';
import { TFAQs } from '../Common/FAQS';
import PartnerPageDataService from '../partner-pages/services/partner-pages.service';
import { IFintooResponse } from './types';

const { publicRuntimeConfig } = getConfig();

const redirection = (
  data: IFintooResponse | null,
  url: URL,
  redirectionEndPoint = publicRuntimeConfig.SSO_MINI_ENDPOINT
) => {
  if (!window) return;
  if (url.href.includes('return_path')) {
    window.location.href = `${redirectionEndPoint}${url.search}`.concat(
      data?.email ? `&email=${data.email}` : ''
    );
  }
  window.location.href =
    `${redirectionEndPoint}?product=cleartax&return_path=${btoa(
      `${url.pathname == '/' ? '' : url.pathname}${url.search}`
    )}`.concat(data?.email ? `&email=${data.email}` : '');
};
export const partnersApi: Record<
  string,
  {
    partnerApiCall: () => Promise<IFintooResponse | null>;
    onRedirection: (data: IFintooResponse | null, url: URL) => void;
  }
> = {
  'partner-fintoo': {
    partnerApiCall: () => {
      if (window) {
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        const userId = searchParams.get('user_id');
        if (userId) return PartnerPageDataService.fintooSignup(String(userId));
        else return Promise.resolve(null);
      } else {
        return Promise.resolve(null);
      }
    },
    onRedirection: (data, url) => redirection(data, url),
  },
  'partner-niyo': {
    partnerApiCall: () => {
      if (!window) return Promise.resolve(null);
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const code = searchParams.get('code');
      if (code) return PartnerPageDataService.niyoSignup(String(code));
      return Promise.resolve(null);
    },
    onRedirection: (data, url) => redirection(data, url),
  },
  'partner-l-t-finance': {
    partnerApiCall: () => {
      if (!window) return Promise.resolve(null);
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const encryptedData = searchParams.get('ed');
      if (encryptedData)
        return PartnerPageDataService.ltFinanceSignup(String(encryptedData));
      return Promise.resolve(null);
    },
    onRedirection: (data, url) =>
      redirection(data, url, publicRuntimeConfig.SSO_ENDPOINT),
  },
  'partner-altswealth': {
    partnerApiCall: () => {
      if (!window) return Promise.resolve(null);
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const email = searchParams.get('email');
      setSessionCookie('altswealth-email', email ?? '');
      const userId = searchParams.get('userId');
      setSessionCookie('altswealth-userId', userId ?? '');
      if (email) {
        window.location.href = `${
          publicRuntimeConfig.SSO_MINI_ENDPOINT
        }?product=cleartax&return_path=${btoa(
          '/filing/?showplan=1'
        )}&email=${email}`;
      }
      return Promise.resolve(null);
    },
    onRedirection: (data, url) => redirection(data, url),
  },
  'partner-onepercent': {
    partnerApiCall: () => {
      if (!window) return Promise.resolve(null);
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const token = searchParams.get('token');

      if (token) return PartnerPageDataService.onePercentSignup(String(token));
      return Promise.resolve(null);
    },
    onRedirection: (data, url) => redirection(data, url),
  },
  'partner-aubank-business': {
    partnerApiCall: () => {
      if (!window) return Promise.resolve(null);
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const code = searchParams.get('code');
      if (code) {
        return PartnerPageDataService.partnerSignup(url.search);
      }
      return Promise.resolve(null);
    },
    onRedirection: (data, url) => redirection(data, url),
  },
  'partner-spare8': {
    partnerApiCall: () => {
      if (!window) return Promise.resolve(null);
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const email = searchParams.get('email');
      if (email) {
        window.location.href = `${
          publicRuntimeConfig.SSO_MINI_ENDPOINT
        }?product=cleartax&return_path=${btoa('/filing/')}&email=${email}`;
      }
      return Promise.resolve(null);
    },
    onRedirection: (data, url) => redirection(data, url),
  },
};

export const partnerPagesRedirection = ({
  e,
  router,
  partnerData,
}: {
  e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement>;
  router: NextRouter;
  partnerData: IFintooResponse | null;
}): void => {
  const target = e.target as HTMLAnchorElement;
  const parentTarget = target.closest('a') as HTMLAnchorElement;
  const partnerSlug = String(router.query?.static);
  if (parentTarget && partnerSlug && partnersApi[partnerSlug]) {
    const href = parentTarget.href;
    e.stopPropagation();
    e.preventDefault();
    const url = new URL(href);
    partnersApi[partnerSlug]?.onRedirection(partnerData, url);
  }
};

export const getPartnerFaqs = (faqSection: TFAQSection): TFAQs => {
  if (faqSection.customEnabled)
    return faqSection.faqs.map((item) => {
      return {
        header: item.question,
        content: <p>{item.answer}</p>,
      };
    });
  return partnerFAQs;
};
